import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useContent } from '../contexts/ContentContext';
import { ShieldCheck, Settings as SettingsIcon } from 'lucide-react';

export const CookieConsent: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const { t, consent, updateConsent, lang } = useContent();

  useEffect(() => {
    if (!consent.responded) {
      const timer = setTimeout(() => setIsVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, [consent.responded]);

  const handleAll = () => {
    updateConsent({ analytics: true, marketing: true, responded: true });
    setIsVisible(false);
  };

  const handleNecessary = () => {
    updateConsent({ analytics: false, marketing: false, responded: true });
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 md:bottom-8 md:left-8 md:right-8 z-[1500] animate-in slide-in-from-bottom-10 duration-700 pointer-events-none">
      <div className="max-w-6xl mx-auto bg-[#1a141f]/95 backdrop-blur-2xl border border-white/10 rounded-[24px] md:rounded-[40px] p-6 md:p-10 shadow-[0_40px_120px_rgba(0,0,0,0.9)] flex flex-col lg:flex-row items-center gap-6 md:gap-10 bg-grid overflow-hidden relative pointer-events-auto">
        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-accent via-orange-400 to-accent opacity-50"></div>
        
        <div className="flex-grow relative z-10">
          <div className="flex items-center gap-3 mb-3 md:mb-4">
             <div className="p-2 bg-accent/10 rounded-lg text-accent">
                <ShieldCheck size={20} />
             </div>
             <h4 className="text-white font-gaming font-bold uppercase tracking-[0.2em] text-lg md:text-xl">Privacy Control</h4>
          </div>
          <p className="text-gray-400 text-sm md:text-base leading-relaxed font-light max-w-4xl">
            {lang === 'en' 
              ? "We value your privacy. We use cookies to enhance your experience, serve personalized content, and analyze our traffic. You can choose to accept all or only essential cookies." 
              : "Cijenimo Vašu privatnost. Koristimo kolačiće da bismo poboljšali Vaše iskustvo, prikazali personalizovan sadržaj i analizirali posjećenost. Možete prihvatiti sve ili samo neophodne kolačiće."}
            <Link to="/privacy-policy" className="text-accent hover:underline font-bold ml-2 whitespace-nowrap">Read Policy</Link>
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-3 w-full lg:w-auto shrink-0 relative z-10">
          <Link 
            to="/cookies" 
            onClick={() => setIsVisible(false)}
            className="flex items-center justify-center gap-2 px-5 py-3.5 md:px-6 md:py-4 rounded-xl md:rounded-2xl border border-white/5 text-gray-500 hover:text-white hover:bg-white/5 transition-all text-[10px] md:text-[11px] font-bold uppercase tracking-widest bg-black/20"
          >
            <SettingsIcon size={14} /> {lang === 'en' ? 'Customize' : 'Prilagodi'}
          </Link>
          <button 
            onClick={handleNecessary}
            className="px-5 py-3.5 md:px-6 md:py-4 rounded-xl md:rounded-2xl border border-white/10 text-gray-300 hover:text-white hover:bg-white/5 transition-all text-[10px] md:text-[11px] font-bold uppercase tracking-widest bg-black/40"
          >
            {lang === 'en' ? 'Essential Only' : 'Samo Neophodni'}
          </button>
          <button 
            onClick={handleAll}
            className="px-8 py-3.5 md:px-10 md:py-4 rounded-xl md:rounded-2xl bg-accent text-white hover:brightness-110 transition-all text-[10px] md:text-[11px] font-bold uppercase tracking-widest shadow-xl shadow-accent/20"
          >
            {lang === 'en' ? 'Accept All' : 'Prihvati Sve'}
          </button>
        </div>
      </div>
    </div>
  );
};